import { ReactElement } from 'react';

import StaarImage from '../../assets/images/LandingPage/StaarImage.png';
import StaarTestPrepPageContent from '../../components/_organisms/StaarTestPrepPageContent';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StaarTestPrepPage: NextPageWithLayout = () => {
  return <StaarTestPrepPageContent />;
};

StaarTestPrepPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="STAAR Test Prep"
      subTitle="The best way to prepare the 48% of students below grade level reading for the Texas STAAR"
      primaryActionText="Get a quote"
      primaryActionLinkOverride="https://share.hsforms.com/1C9S5i0vURJqvr5MnJ8VXVA4evga"
      primaryActionLinkIsExternal={true}
      image={StaarImage}
      hideBlobs={false}
      hideActions={false}
    >
      {page}
    </LandingPageLayout>
  );
};

export default StaarTestPrepPage;
